import { render, staticRenderFns } from "./InteresesPage.vue?vue&type=template&id=483e53df&scoped=true"
import script from "./InteresesPage.vue?vue&type=script&lang=js"
export * from "./InteresesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483e53df",
  null
  
)

export default component.exports